export default {
  guests_pay: 'Goście płacą {{amount}} przy zamówieniu (najnowszy kurs wymiany).',
  missing_rate: 'Brak jeszcze kursu wymiany dla {{currency}}, więc goście płacą {{amount}} bez przeliczenia.',
};
